import {
  Button,
  Card as Card1,
  Col,
  DatePicker,
  Divider,
  Form,
  Image,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import ReactSelect from "react-select";

import TextArea from "antd/lib/input/TextArea";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";
import { Breadcrumbs, H6 } from "../../../../AbstractElements";
import { ProjectFileApi, VendorApi } from "../../../../api";
import { createBid } from "../../../../api/bid.api";
import { fetchOrganisationDetails } from "../../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { DocumentUpload } from "../Po/document-upload";
import ItemTable from "./itemTable";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const { Option } = Select;
const { Text } = Typography;
const BiddingForm = (props) => {
  const logger = React.useContext(LoggerContext);

  const { user } = props.settings;
  const { poId } = useParams();
  const history = useNavigate();
  const [items, setItems] = useState([]);
  const [fileUploading, setFileUploading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [finalValue, setFinalValue] = useState({
    bid_due_date: moment().format("YYYY-MM-DD"),
    desired_delivery_date: moment().format("YYYY-MM-DD"),
    organisation: user?.organisation?.organisation_id,
    project: props.settings?.project?.id,
    documents: [],
    bid_description: "",
  });
  const [bidDetails, setBidDetails] = useState(null);

  const [organisationDetails, setOrganisationDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [vendorError, setVendorError] = useState(false);

  const location = useLocation();
  const ref = useRef();
  const poFormRef = useRef();
  useEffect(() => {
    getOrganisationDetails();
    fetchVendors({ branch: props.settings.branch?.id });
  }, []);
  useEffect(() => {
    console.log("items bid", items);
  }, [items]);
  const getOrganisationDetails = () => {
    fetchOrganisationDetails().then((res) => {
      setOrganisationDetails(res);
    });
  };
  const fetchVendors = (params = {}) => {
    axios.get(`${VendorApi}`, { params: { ...params } }).then((res) => {
      setVendors(res.data);
    });
  };

  const setValuesForBid = ({ key, value }) => {
    let valuesOfBid = { ...finalValue };
    valuesOfBid[key] = value;
    setFinalValue({
      ...valuesOfBid,
    });
  };

  const sendBid = () => {
    logger.log(LogEvents.bidSubmit, {});
    setVendorError(false);

    const newValue = finalValue;
    console.log(fileList, "ddd", newValue);

    setLoading(true);
    if (newValue.desired_delivery_date && newValue.project) {
      if (items.length < 1) {
        toast.error("Choose at least one item!");
        setLoading(false);
        return;
      }
      var arr = items;
      var newArr = [];
      for (var i = 0; i < arr?.length; i++) {
        var data = arr[i];
        const formData = {
          item: data.id,
          quantity: data.quantity,
        };
        if (data.boq_sub_item) {
          formData.item = data.item_id ?? data?.item;
          formData.sub_item = data.id ?? data.sub_item;
        } else {
          formData.item = data.id;
        }

        if (location.pathname.includes("edit")) {
          if (data.sub_item || data.boq_sub_item) {
            formData.item = data.item;
            formData.sub_item = data.sub_item;
          } else {
            formData.item = data.item;
          }
        }
        newArr.push(formData);
      }
      newValue.bid_items = newArr;
      newValue.documents = newValue.documents?.map((doc) => doc.id);
      newValue.organisation = organisationDetails?.id;
      newValue.vendor = selectedVendors;

      if (!newValue.vendor) {
        setVendorError(true);
        return;
      }
      if (location.pathname.includes("edit")) {
        newValue.po_id = poId ?? location.state.editId;
        newValue.po_number = bidDetails?.po_number;
      }
      createBid({ data: newValue }).then(() => {
        history(`/app/project/biddings`, {
          state: { id: props.settings?.project?.id },
        });
        toast.success("Bid Sent Successfully!");
        setLoading(false);
      });
    } else {
      toast.error("Enter all fields!");
      setLoading(false);
    }
  };

  const getFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["B", "KB", "MB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(parseFloat(bytes / Math.pow(k, i))) + " " + sizes[i];
  };
  const onDocumentAdd = async (file) => {
    try {
      setFileUploading(true);
      const result = await Promise.all(
        Object.keys(file).map((key) => {
          console.log("KK", key, file[key]);
          const formData = new FormData();
          formData.append("file", file[key], file[key].name);
          formData.append("file_name", file[key].name);
          formData.append("project", props.settings?.project?.id);
          formData.append("file_size", getFileSize(file[key]?.size));
          return axios
            .post(ProjectFileApi, formData)
            .then((res) => {
              let finalValueTemp = { ...finalValue };
              finalValueTemp.documents?.push({
                document: res?.data?.file,
                id: res?.data?.id,
                file_name: res?.data?.file_name,
              });
              setFileList([...finalValueTemp.documents]);
              setFinalValue({ ...finalValueTemp });
            })
            .catch((e) => {
              console.log("e", { e });
              toast.error("Something went wrong!");
            });
        })
      );

      toast.success("Files Upload Successfully !");
    } catch (e) {
      console.log("i-log> ", e);
    } finally {
      setFileUploading(false);
    }
  };

  const onDocumentRemove = (file) => {
    const id = file.id;
    console.log(
      "i-log> files",
      fileList,
      fileList.filter((file) => file.id !== id)
    );
    setFileList(fileList.filter((file) => file.id !== id));
    setFinalValue({
      ...finalValue,
      documents: finalValue.documents.filter((file) => file.id !== id),
    });
  };

  return (
    <React.Fragment>
      <Breadcrumbs parent="Project" title="Bid Form" mainTitle="Bid Form" />
      <Container fluid={true}>
        <Spin
          spinning={loading}
          size="large"
          style={{ position: "fixed", marginTop: "30vh" }}
        >
          <Card ref={ref}>
            <CardBody>
              <Form ref={poFormRef} id="poForm">
                {/* Main Details */}
                <Row gutter={24} justify="center" align="middle">
                  <Col className="d-flex justify-content-center" sm={12}>
                    <Image
                      src="https://mysite-user-images.s3.ap-south-1.amazonaws.com/1659693186644-MD-for-procurement.svg"
                      height={80}
                    />
                  </Col>
                  <Col sm={12}>
                    <Row gutter={24} className="mt-3">
                      <Col sm={6} md={6}>
                        Created By :
                      </Col>
                      <Col sm={18} md={18}>
                        {user.name}
                      </Col>
                    </Row>
                    <Row gutter={24} className="mt-3">
                      <Col sm={6} md={6}>
                        Contact Details :
                      </Col>
                      <Col sm={18} md={18}>
                        {user.contact + ", " + user.email}
                      </Col>
                    </Row>
                    <Row gutter={24} className="mt-3">
                      <Col sm={6} md={6}>
                        Bill Due Date :
                      </Col>
                      <Col sm={18} md={18}>
                        <Form.Item
                          name="due_date"
                          rules={[
                            {
                              required: true,
                              message: " Bid due date is required",
                            },
                          ]}
                        >
                          <DatePicker
                            value={moment(finalValue?.bid_due_date)}
                            allowClear={false}
                            defaultValue={moment(finalValue?.bid_due_date)}
                            onChange={(e) => {
                              setValuesForBid({
                                key: "bid_due_date",
                                value: moment(e).format("YYYY-MM-DD"),
                              });
                            }}
                            className="w-100"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={24}>
                      <Col sm={6} md={6}>
                        Desired Delivery Date :
                      </Col>
                      <Col sm={18} md={18}>
                        <Form.Item
                          name="desired_delivery_date"
                          rules={[
                            {
                              required: true,
                              message: "Delivery Date is required",
                            },
                          ]}
                        >
                          <DatePicker
                            value={moment(finalValue.desired_delivery_date)}
                            allowClear={false}
                            defaultValue={moment(
                              finalValue?.desired_delivery_date
                            )}
                            onChange={(e) => {
                              setValuesForBid({
                                key: "desired_delivery_date",
                                value: moment(e).format("YYYY-MM-DD"),
                              });
                            }}
                            className="w-100"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* Bill To */}
                <Row gutter={24} className="mt-3">
                  <Col sm={12}>
                    <Card1>
                      <div className="">
                        <H6>Bill To</H6>
                      </div>
                      <Row gutter={24} className="mt-3">
                        <Col sm={6} md={6}>
                          Name
                        </Col>
                        <Col sm={18} md={18}>
                          {organisationDetails?.name}
                        </Col>
                      </Row>
                      <Row gutter={24} className="mt-3">
                        <Col sm={6} md={6}>
                          Address :
                        </Col>
                        <Col sm={18} md={18}>
                          {organisationDetails?.address}
                        </Col>
                      </Row>
                    </Card1>
                  </Col>
                  {/* Vendor Details */}
                  <Col sm={12}>
                    <Card1 style={{ padding: "0px" }}>
                      <div className="">
                        <H6>Vendor Details</H6>
                      </div>
                      <div className="mt-3">
                        <ReactSelect
                          options={vendors?.map((vendor) => ({
                            value: vendor.id,
                            label: vendor.name,
                          }))}
                          isMulti
                          onChange={(selected) => {
                            console.log("setSelectedVendors", selected);
                            setVendorError(false);
                            const ids = selected.map((vendor) => vendor?.value);
                            console.log(ids);
                            setSelectedVendors(ids);
                          }}
                        />
                        {vendorError && (
                          <span style={{ color: "red" }}>
                            Please select a vendor
                          </span>
                        )}
                        {/* <Select
                          mode="multiple"
                          // showSearch
                          // filterOption={(input, option) => {
                          //   console.log("VENDOR LIST!", option);
                          //   let obj = this.props.vendorList.filter(
                          //     (x) => x._id == option.value
                          //   )[0];
                          //   let search = {
                          //     name: obj.name,
                          //     contactPerson: obj.contact_person,
                          //     tags: obj.tags,
                          //     address: obj.billing_address,
                          //   };
                          //   return (
                          //     JSON.stringify(search)
                          //       .toLowerCase()
                          //       .indexOf(input.toLowerCase()) >= 0
                          //   );
                          // }}
                          style={{ width: 300 }}
                          fullWidth
                          maxTagCount="responsive"
                          placeholder="Select Vendors"
                          value={selectedVendors}
                          onChange={(value) => {
                            setSelectedVendors([...value]);
                          }}
                          optionLabelProp="label"
                          className="hide-tag"
                        >
                          {vendors?.map((vendor) => (
                            <Option value={vendor?.id} label={vendor?.name}>
                              <Row justify="space-between">
                                <Col xs={24}>
                                  <Text
                                    type="secondary"
                                    style={{ fontSize: 10 }}
                                  >
                                    Contact: {vendor?.contact_person}
                                  </Text>
                                </Col>
                                <Col xs={24}>
                                  <Text style={{ fontSize: 12 }}>
                                    {vendor?.name}
                                  </Text>
                                </Col>
                                <Col xs={24}>
                                  <Text italic>
                                    {vendor?.tags?.length
                                      ? vendor.tags.join(", ")
                                      : null}
                                  </Text>
                                </Col>
                              </Row>
                            </Option>
                          ))}
                        </Select> */}
                      </div>
                      {/* <div className="mt-2">
                        {selectedVendors?.map((each) => (
                          <Tag
                            icon={
                              <CloseCircleOutlined
                                onClick={() => {
                                  setSelectedVendors(
                                    selectedVendors?.filter((x) => x != each)
                                  );
                                }}
                              />
                            }
                          >
                            {vendors?.filter((x) => x?.id === each)[0]?.name}
                          </Tag>
                        ))}
                      </div> */}
                    </Card1>
                  </Col>
                </Row>
                <div className="mt-3">
                  <Card1>
                    <ItemTable
                      projectId={props.settings?.project?.id}
                      editId={editId}
                      //   taxTypes={taxTypes}
                      //   setDefaultTax={setDefaultTax}
                      defaultSelectedItems={[]}
                      setItems={setItems}
                    />
                  </Card1>
                </div>
                <Row gutter={24} className="mt-3">
                  <Col sm={12}>
                    <H6>Bid Description</H6>
                    <TextArea
                      autoSize={{ minRows: 3 }}
                      placeholder="Type bid description "
                      onChange={(e) => {
                        setFinalValue({
                          ...finalValue,
                          bid_description: e.target.value,
                        });
                      }}
                    />
                  </Col>
                  <Col sm={1}>
                    <Divider type="vertical" style={{ height: "100%" }} />
                  </Col>
                  <Col sm={11}>
                    <div className="">
                      <div>
                        <span
                          style={{ fontSize: "18px", fontWeight: "bolder" }}
                        >
                          Documents
                        </span>{" "}
                        {"(Total files size should be less than 25MB)"}
                      </div>
                      <div className="py-2">
                        <DocumentUpload
                          onDocumentAdd={onDocumentAdd}
                          onDocumentRemove={onDocumentRemove}
                          documents={fileList}
                          loading={fileUploading}
                        />
                      </div>
                    </div>
                  </Col>
                  {/* <Col sm={11}>
                    <H6>Documents</H6>
                    <Upload className="mt-2">
                      <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                  </Col> */}
                </Row>

                <div className="d-flex justify-content-end">
                  {location.pathname.includes("edit") ? (
                    <Button
                      className="btn btn-primary text-white"
                      size="large"
                      form="poForm"
                      //   onClick={() => sendPo()}
                      htmlType="submit"
                    >
                      Save Changes
                    </Button>
                  ) : (
                    <Button
                      className="btn btn-primary text-white"
                      size="large"
                      form="poForm"
                      onClick={() => sendBid()}
                      htmlType="submit"
                    >
                      Create Bid
                    </Button>
                  )}
                </div>
              </Form>
            </CardBody>
          </Card>
        </Spin>
      </Container>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(BiddingForm);
